import React from "react";

export const BaseUrlContext = React.createContext<string>("");

export function useBaseUrl() {
  return React.useContext(BaseUrlContext);
}
